import { Save } from "lucide-react";
import useNewsEditor, { getSaveLabel } from "../../hooks/useNewsEditor";
import { NewsArticleBodyFields, NewsArticleDetailsFields } from "./NewsEditorFields";

export default function NewsEditor({ article, onSaved }) {
  const { error, form, saveArticle, state, update } = useNewsEditor(article, onSaved);
  const saveLabel = getSaveLabel(article, state);

  return (
    <form
      className="admin-editor-form"
      data-testid="news-editor-form"
      onSubmit={saveArticle}
    >
      <span className="editor-mode" data-testid="news-editor-mode">
        {article ? "Edit article" : "New article"}
      </span>
      <NewsArticleDetailsFields form={form} update={update} />
      <NewsArticleBodyFields form={form} update={update} />
      {error && (
        <p className="form-error" data-testid="news-editor-error">
          {error}
        </p>
      )}
      <button
        className="button button--red"
        data-testid="save-news-article-button"
        disabled={state === "loading"}
      >
        <Save size={16} />
        {saveLabel}
      </button>
    </form>
  );
}